export default {
  firebase: {
    apiKey: "AIzaSyCPUsizYS3DwLzTCRe6DZez-EtYm9tVpbM",
    authDomain: "letsupgrade-2019.firebaseapp.com",
    databaseURL: "https://letsupgrade-2019.firebaseio.com",
    projectId: "letsupgrade-2019",
    storageBucket: "letsupgrade-2019.appspot.com",
    messagingSenderId: "78167447044",
    appId: "1:78167447044:web:f06a3e0c126e9435cbc751"
  }
}



// WEBPACK FOOTER //
// ./src/env.staging.js